import React from "react";
import MainTitle from './elements/MainTitle';
import ListPoints from './elements/ListPoints';
import CenteredContentWrapper from '../elements/CenteredContentWrapper';
import { getImage } from "../../helpers/images";

export default class CapsulePortalBlock extends React.PureComponent {
    render() {
        let title = 'All accessible via the Capsule Portal';

        return (
            <div className={'capsule-portal'}>
                <MainTitle text={title}/>

                <img className={'capsule-portal-image'} alt={title} src={getImage('capsule-portal-2.webp')}/>

                <CenteredContentWrapper className={'capsule-portal-list'}>
                    <div className={'title'}>
                        {title}
                    </div>

                    <div className={'wrapper'}>
                        <div className={'description main-title'}>
                            Manage your Capsule sounds with our intuitive desktop app.
                        </div>

                        <ListPoints points={[
                            'Download full libraries',
                            'Download individual sounds',
                            'Curate your own collections',
                            'Favorite sounds',
                            'Sync your presets to the cloud',
                        ]}/>
                    </div>
                </CenteredContentWrapper>
            </div>
        );
    }
}

